export default "__VITE_ASSET__BzGRI8kQ__"